/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FunnelStatusStepByStepInstructionStep } from './FunnelStatusStepByStepInstructionStep';
export type FunnelStatusStepByStepInstruction = {
    type: FunnelStatusStepByStepInstruction.type;
    steps: Array<FunnelStatusStepByStepInstructionStep>;
};
export namespace FunnelStatusStepByStepInstruction {
    export enum type {
        STEP_BY_STEP = 'stepByStep',
    }
}

